<div class="container-fluid webView" style="  padding: {{modalshow ? '10px 20px' : '0px 30px'}}; {{modalshow ? 'padding-top: 0px;' : ''}}">
    <!-- Header -->
    <div class="col-12 col-sm-12 bgWhite webView" style="padding: 15px 0px 0px 0px;">
        <div class="col-5 col-sm-5" style="padding: 0px;display: inline-block;">
            <h3 class="lblHeader newHeader" style="display: inline-block;">
                Categories
            </h3>
        </div>

        <div class="col-7 col-sm-7" style="padding: 0px; text-align: right; display: inline-block;">
            <span class="btn orangeButton" (click)="open(mymodal,0)" title="Add New Category"
                    style="border-radius: 3px; cursor: pointer; padding: 4px 9px !important; margin-right: 5px;">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
            </span>
            <span *ngIf="modalshow" class="closeMdl ng-scope" style="margin-right: 0%; padding: 6px 10px !important;"
                (click)="closeModel()">
                <i class="zmdi zmdi-close" style="position: relative; top: 0.5px;"></i>
            </span>
            <div *ngIf="!modalshow" style="display: inline-block; text-align: right; padding: 0px; margin-left: 5px;" >
                <span class="darkBlueButton brdrRadius3" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px !important;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
                </span>
            </div>
        </div>

    </div>
    <!-- <div class="col-md-12 bgWhite padHeder"  style="padding: 15px 0px 0px 0px;">
        <div class="col-md-4" style="padding: 0px; display: inline-block;">
            <h3 style="display: inline-block;">Categories</h3>
            <span style="float: right;">
                <span class="label" (click)="open(mymodal,0)"
                    style="border-radius: 50%; top: 5px; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
            </span>
        </div>
    </div> -->

    <!-- Body -->
    <div class="row marginZero">
        <div class="col-md-12" style="padding: 0px;">
            <!-- left -->
            <div class="col-md-12 mainCardHeader" style="display: inline-block;overflow: auto; height: {{modalshow ? '350px' : ''}}; ">
                <div class="{{modalshow ? 'col-12 col-sm-12' : 'col-5 col-sm-5'}} " style="padding: 0px;">
                    <div id="divScrID" class="col-md-12" style="margin-top: 15px; padding: 0px;">
                        <div *ngFor="let s of categories let i = index"  style="margin-bottom: 10px;color: #e88421; background: white;border-radius: 3px !important;border: 1px solid;" class="col-12 col-sm-12 {{changeColor(i % 7)}}"> 
                            <div class="row">                                     
                                <div class="col-md-8 font13" style="padding: 0px 0px 5px 15px;cursor: pointer;" title="View sub-categories" (click)="openSubCat(subCategories,s.cid)">
                                    <span style="font-size: 13px;">{{s.cnm}}</span>                           
                                </div>       
                                <div class="col-md-4 font13" style="text-align: right;">
                                    <div class="lableBtnOrange" style="padding: 2px 9px 2px !important; margin-right: 10px;display: inline-block;cursor: pointer;" title="Manage sub-categories" (click)="openSubCat(subCategories,s.cid)">
                                        <i class="fa fa-chevron-right"></i>
                                    </div> 
                                    <div class="lableBtnOrange" style="margin-right: 10px;display: inline-block;cursor: pointer;" title="Edit" (click)="open(mymodal,s.cid)">
                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                    </div>
                                    <div class="lableBtnOrange" style="display: inline-block;cursor: pointer;"
                                        title="Delete" (click)="deleteCat(i)">
                                        <i class="fa fa-trash"></i>
                                    </div>
                                </div>
                                <div class="col-md-8" style="display: inline-block;color: #777 !important; font-size: 12px !important;margin-bottom: 5px;">
                                    <span>{{s.sub.length}} {{s.sub.length == 1 || s.sub.length == 0 ? 'sub-category' :
                                        'sub-categories'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bgWhite" style="padding-top: 15px;" *ngIf="categories.length == 0">
                        <div class="nrf brdrRadius3" style="margin-left: 15px;cursor: pointer;" (click)="open(mymodal,0)">
                            Click here to add a category.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col-md-6" style="display: inline-block;margin-top: 20px;padding: 0px;"> 
            <span style="float: left;">
                <span class="label" (click)="open(mymodal,0)"
                    style="border-radius: 50%; top: 5px; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
            </span>
        </div> -->
</div>

<div class="container-fluid mobView">
    <!--Header-->
    <div class="col-12 col-md-12 bgWhite padHeder mobView" style="padding: 15px 0px 0px 0px;">
        <div class="col-7 col-md-7 pad0" style="display: inline-block;vertical-align: sub;">
            <span *ngIf="!modalshow" style="font-size: 20px; margin-right: 10px;" (click)="backBtn()">
                <i class="fa fa-chevron-left"></i>
            </span>
            <h4 style="display: inline-block;">Categories</h4>
        </div>
        <div class="col-5 col-md-5 pad0" style="display: inline-block;">
            <span style="float: right;">
                <span class="label addOrgBtnM brdrRadius3" style="vertical-align: middle;" (click)="open(mymodal,0)">
                   <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px;vertical-align: text-bottom;margin-right: 8px;"></i><span>Add</span>
                </span>
                <span *ngIf="modalshow" class="closeMdl ng-scope" style="margin-left: 5px; padding: 6px 12px !important;top:1px"
                (click)="closeModel()">
                <i class="zmdi zmdi-close" style="position: relative; top: 0.5px;"></i>
            </span>
            </span>
        </div>
    </div>

    <!-- Body -->
    <div class="row marginZero">
        <div class="col-12 col-sm-12" style="padding: 0px;">
            <!-- Categories -->
            <div class="col-12 col-sm-12 mainCardHeader" style="display: inline-block;padding: 0px;">
                <div id="divScrID" class="col-12 col-sm-12" style="margin-top: 15px;">
                    <div *ngFor="let s of categories let i = index"  style="margin-bottom: 15px;" class="col-12 col-sm-12 orngBadgeM"> 
                        <div class="row">                                     
                            <div class="col-8 col-sm-8 font13" style="padding: 0px 0px 0px 15px;" (click)="openSubCat(subCategories,s.cid)">
                                <span style="font-weight: 400;">{{s.cnm}}</span>                        
                            </div>       
                            <div class="col-4 col-sm-4 font13" style="text-align: right;">
                                <div style="margin-right: 20px; display: inline-block;cursor: pointer;" title="Add sub-categories" (click)="openSubCat(subCategories,s.cid)">
                                    <i class="fa fa-plus"></i>
                                </div> 
                                <div style="margin-right: 20px;display: inline-block;" title="Edit" (click)="open(mymodal,s.cid)">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </div> 
                                <div style="display: inline-block;" title="Delete" (click)="deleteCat(i)">
                                    <i class="fa fa-trash"></i>
                                </div>                                   
                            </div>
                            <div class="col-8 col-sm-8 font12" style="display: inline-block;padding: 3px 0px 5px 15px;color: #777;">
                                <span>{{s.sub.length}} {{s.sub.length == 1 || s.sub.length == 0 ? 'sub-category' : 'sub-categories'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bgWhite" style="padding-top: 15px;" *ngIf="categories.length == 0">
                    <div class="nrf brdrRadius3" style="margin-left: 15px;" (click)="open(mymodal,0)">
                        Click here to add a category.
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>

<!--Add Category-->
<ng-template #mymodal let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">{{isEditCategory == false ? 'Add Category' : 'Edit Category'}}</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right; padding: 10px 12px !important;" 
                    (click)="closeModal()"></i>
                    <!-- <span  class="closeMdl" style="margin-left: 85px; margin-right: 0%; padding: 6px 12px !important;"
                    (click)="closeModal()">
                    <i class="zmdi zmdi-close"></i>
                </span> -->
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 0px 15px 15px 15px;">
            <div class="col-md-12 col-xs-12 col-12" style="padding: 0px 15px 0px 0px;;display: inline-block;">
                <input type="text" [(ngModel)]="tempData.categoryName" class="form-control formCtlFltr" maxlength="50" style="text-indent: 2px;font-size: 13px;"
                    placeholder="Enter Category">
            </div>
        </div>

        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px;">
            <span class="btn-green brdrRadius3" style="padding: 2px 10px; font-size: 14px; line-height: 25px;"
                (click)="isEditCategory == false ? saveNewCat() : editCatSave()">
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
        </div>
    </div>
</ng-template>

<ng-template #subCategories let-modal>
    <app-multiple-select-item (newItemEvent)="getSelectedItem($event)"></app-multiple-select-item>
</ng-template>
